import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy,  PathLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { IconSetService } from '@coreui/icons-angular';
   

// Import containers
import { DefaultLayoutComponent } from './containers';
const APP_CONTAINERS = [ 
  DefaultLayoutComponent 
];

 

// Import 3rd party components    

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { AutoTabDirective, AutoTabDirectivePrev } from './shared/directives/autotabdirective';
import { NgxSpinnerModule } from "ngx-spinner"; 
import { ErrorComponent } from './views/error/error.component';
import { PaymentRedirectionComponent } from './views/payment-redirection/payment-redirection.component';

 
import { EventManager } from '@angular/platform-browser';

@NgModule({
  declarations: [
    
   
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ToastrModule.forRoot({preventDuplicates: true}),
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppComponent,
    DefaultLayoutComponent,
    AutoTabDirective,
    AutoTabDirectivePrev,
    ErrorComponent,
    PaymentRedirectionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],  
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    IconSetService,
  ],
})
export class AppModule {
  constructor(private eventManager: EventManager) {
    if (!(this.eventManager as any).addGlobalEventListener) {
      (this.eventManager as any).addGlobalEventListener = (target: string, eventName: string, handler: Function) => {
        return this.eventManager.addEventListener(target as any, eventName, handler as any);
      };
    }
  }
}
